import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ShowAllClassicProductsEasterEgg;
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbPortalResources from "abportal/generated/locale/AbPortalResources";
import { LocalStorageEasterEgg } from "abreact/app/easterEggs/EasterEggs";
import * as React from "react";
export const PortalProducts = {
  AG: "AG",
  MHUB: "MHUB",
  CC: "CC",
  EI: "EI",
  DCS: "DCS",
  QIADMIN: "QIADMIN",
  TRW: "TRW",
  CAFE: "CAFE",
  AIC: "AIC"
};
// TODO: promote to shared component?
const AbReg = () => /*#__PURE__*/React.createElement("span", {
  className: "ab-superscript"
}, "\xAE");

/*
 * TODO: Hardcoded set of context roots that line up with the ansible deployment.
 * Helm deployment uses different context roots.
 */

export const allProducts = {
  [PortalProducts.AG]: {
    product: PortalProducts.AG,
    contextRoot: "authgateway",
    name: "Authorization Gateway",
    plainTextName: "Authorization Gateway"
  },
  [PortalProducts.MHUB]: {
    product: PortalProducts.MHUB,
    contextRoot: "metadatahub",
    // eslint-disable-next-line i18next/no-literal-string
    name: /*#__PURE__*/React.createElement(React.Fragment, null, "Metadata Hub", /*#__PURE__*/React.createElement(AbReg, null)),
    plainTextName: "Metadata Hub"
  },
  [PortalProducts.CC]: {
    product: PortalProducts.CC,
    contextRoot: "controlcenter",
    name: /*#__PURE__*/React.createElement(React.Fragment, null, "Control>Center", /*#__PURE__*/React.createElement(AbReg, null)),
    plainTextName: "Control>Center"
  },
  [PortalProducts.EI]: {
    product: PortalProducts.EI,
    contextRoot: undefined,
    // Express>It endpoints are now all made available through Cafe
    name: /*#__PURE__*/React.createElement(React.Fragment, null, "Express>It", /*#__PURE__*/React.createElement(AbReg, null)),
    plainTextName: "Express>It"
  },
  [PortalProducts.DCS]: {
    product: PortalProducts.DCS,
    contextRoot: "datacatalog",
    name: "Data Catalog Services",
    plainTextName: "Data Catalog Services"
  },
  [PortalProducts.QIADMIN]: {
    product: PortalProducts.QIADMIN,
    contextRoot: undefined,
    // Express>It endpoints are now all made available through Cafe
    // eslint-disable-next-line i18next/no-literal-string
    name: /*#__PURE__*/React.createElement(React.Fragment, null, "Query>It", /*#__PURE__*/React.createElement(AbReg, null), " Administrator"),
    plainTextName: "Query>It Administrator"
  },
  [PortalProducts.TRW]: {
    product: PortalProducts.TRW,
    contextRoot: undefined,
    // TRW endpoints are now all made available through Cafe
    name: "Technical Repository Web",
    plainTextName: "Technical Repository Web"
  },
  [PortalProducts.CAFE]: {
    product: PortalProducts.CAFE,
    contextRoot: "",
    name: "Cafe",
    plainTextName: "Cafe"
  },
  [PortalProducts.AIC]: {
    product: PortalProducts.AIC,
    contextRoot: "aicentral",
    name: "AI Central",
    plainTextName: "AI Central"
  }
};

// translations need to be loaded before calling this
export const getProductCapabilityLinkInfo = () => ({
  [PortalProducts.MHUB]: {
    findAndExplore: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_findAndExplore(),
      href: "/dg/#/abvdl-component?view=TechnicalAssetsTopicLandingView&topic=TechnicalAssets"
    },
    addDatasets: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_addDatasets(),
      href: "/dg/#/abvdl-component?view=DataAccessTopicLandingView&topic=DataAccess"
    },
    loadToDataLake: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_loadToDataLake(),
      href: "/dg/#/abvdl-component?view=DataPipelinesTopicLandingView&topic=DataPipelines"
    },
    addDQControls: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_addDQControls(),
      href: "/dg/#/abvdl-component?view=DataQualityTopicLandingView&topic=DataQuality"
    },
    semanticDiscovery: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_semanticDiscovery(),
      href: "/dg/#/abvdl-component?view=SemanticDiscoveryLandingView"
    },
    tag: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_tag(),
      href: "/dg/#/abvdl-component?view=VersionTagsLandingPageView"
    },
    promote: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_promote(),
      href: "/dg/#/abvdl-component?view=PromotionLandingView"
    },
    mask: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_mask(),
      href: "/dg/#/abvdl-component?view=DbmLandingView"
    },
    addBusinessTerm: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_addBusinessTerm(),
      href: "/dg/#/abvdl-component?view=BizGlossaryTopicLandingView&topic=BizGlossary"
    },
    exploreTechnicalAssets: {
      productInfo: allProducts.MHUB,
      label: AbPortalResources.productCapabilities_metadataPortal_exploreTechnicalAssets(),
      href: "/dg/#/abvdl-component?view=TechnicalAssetsTopicLandingView&topic=TechnicalAssets"
    }
  },
  [PortalProducts.AG]: {
    manageUsers: {
      productInfo: allProducts.AG,
      label: AbPortalResources.productCapabilities_authGateway_manageUsers(),
      href: "#/abvdl-component?view=AdministrationLandingView"
    },
    assignRoles: {
      productInfo: allProducts.AG,
      label: AbPortalResources.productCapabilities_authGateway_assignRoles(),
      href: "/dg/#/abvdl-component?view=AGGroupsLandingView"
    }
  },
  [PortalProducts.CC]: {
    monitor: {
      productInfo: allProducts.CC,
      label: AbPortalResources.productCapabilities_controlCenter_monitor(),
      href: "#/daily-jobs"
    },
    schedule: {
      productInfo: allProducts.CC,
      label: AbPortalResources.productCapabilities_controlCenter_schedule(),
      href: "#/schedule/system=DEFAULT/monitorMode=grid/groupBy=Application%26Status/group=All"
    }
  }
});
export class ShowAllClassicProductsEasterEgg extends LocalStorageEasterEgg {
  constructor() {
    super("ShowAllClassicProducts", "Show all classic products");
  }
}
_ShowAllClassicProductsEasterEgg = ShowAllClassicProductsEasterEgg;
_defineProperty(ShowAllClassicProductsEasterEgg, "easterEgg", new _ShowAllClassicProductsEasterEgg());
//# sourceMappingURL=PortalProducts.js.map
